(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Model', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/Model'),require('./../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoModel, urls) {
  'use strict';
  /**
    * Model representing a visit
    *
    * @class VisitModel
    * @extends Torso.Model
    * @constructor
    */
  return TorsoModel.extend({
    /**
     * @method url
     * @returns {String} the url for the visit resource.
     * @override
     */
    urlRoot: urls.visitExtService,

    /**
     * Sets the urlRoot to fetch from endpoint for current visit
     *
     * @method initialize
     * @param [attributes={}] {Object} the initial attributes for this model.
     * @param [options={}] {Object} the options for this model.
     *   @param [options.currentVisit=false] {Boolean} if this model is retrieving the current visit (true) or a visit by id (false).
     * @override
     */
    initialize: function(attributes, options) {
      options = options || {};
      this._currentVisit = options.currentVisit || false;
    },

    /**
     * @method url
     * @override
     */
    url: function() {
      var url;
      if (this._currentVisit) {
        url = this.urlRoot + '/current';
      } else {
        // use the default url if not a current visit.
        url = TorsoModel.prototype.url.apply(this, arguments);
      }

      return url;
    }

  });
}));
